import React from 'react'
import Banner from '../Components/Banner'
import pattern from '../Assets/careerbannerpattern.png'
import Breadcrumb from './../Components/Breadcrumb';
import StudyInAmerica from './../Components/Destinations/StudyInAmerica';
import test1 from '../Assets/TEST-PRE/English-Proficiency-Tests-for-Studying-Abroad.jpg'
import test2 from '../Assets/TEST-PRE/Guidance-for-English-Proficiency-Tests.jpg'
import Overseas from '../Components/Testprep/OverseasEducation';
import EnglishExamGuide from './../Components/Testprep/EnglishExamGuide';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const Testprep = () => {
  // check if mobile
  const isMobile = window.innerWidth < 768;

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  // if mobile, just render normally (no motion)
  if (isMobile) {
    return (
      <div>
        {/* Banner */}
        <div>
          <Banner
            className='position-relative'
            subtitle="Nova EduBridge"
             title="Best Courses to Study Abroad"
            buttonText="Avail Free counselling"
            buttonLink="/Contact"
            backgroundImage="/images/test-prep-banner.png"
          />
          <div className='position-absolute pattern'>
            <img src={pattern} alt='pattern' />
          </div>
        </div>

        {/* Breadcrumb */}
        <div>
          <Breadcrumb/>
        </div>

        {/* Study in America / Test Info Section */}
        <div>
          <StudyInAmerica
            heading1="English Proficiency Tests for Studying Abroad"
            img1={test1}
           para1="If you’re planning to study, work, or settle abroad, IELTS TOEFL PTE for overseas education are essential requirements set by universities and immigration authorities as proof of your English language skills. These English proficiency tests evaluate your ability to read, write, speak, and understand English in an academic or professional environment."
            heading2="Guidance for English Proficiency Tests"
            img2={test2}
            para2="At Nova EduBridge, we guide students and professionals through every step of their English test journey, from choosing the right exam to achieving a score that meets the entry requirements of universities, employers, and immigration programs worldwide. The three preferred English proficiency tests for studying abroad are: IELTS, TOEFL, and PTE."
          />
        </div>

        {/* Overseas Section */}
        <div>
          <Overseas/>
        </div>

        {/* English Exam Guide */}
        <div>
          <EnglishExamGuide/>
        </div>
      </div>
    );
  }

  // desktop: keep animations
  return (
    <div>
      {/* Banner */}
      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
        <Banner
          className='position-relative'
          subtitle="Nova EduBridge"
        title="Best Courses to Study Abroad"
          buttonText="Avail FREE counselling"
          buttonLink="/Contact"
          backgroundImage="/images/test-prep-banner.png"
        />
        <div className='position-absolute pattern'>
          <img src={pattern} alt='pattern' />
        </div>
      </motion.div>

      {/* Breadcrumb */}
      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
        <Breadcrumb/>
      </motion.div>

      {/* Study in America / Test Info Section */}
      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
        <StudyInAmerica
          heading1="English Proficiency Tests for Studying Abroad"
          img1={test1}
       para1={
    <>
      If you’re planning to study, work, or settle abroad, one of the first
      requirements from universities and immigration authorities is proof of
      your English language skills.{" "}
      
      <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>
        IELTS TOEFL PTE for overseas education
      </Link>{" "}
      
      are widely accepted tests that evaluate your ability to read, write,
      speak, and understand English in an academic or professional environment.
    </>
  }
          heading2="Guidance for English Proficiency Tests"
          img2={test2}
          para2="At Nova EduBridge, we guide students and professionals through every step of their English test journey, from choosing the right exam to achieving a score that meets the entry requirements of universities, employers, and immigration programs worldwide. The three preferred English proficiency tests for studying abroad are: IELTS, TOEFL, and PTE."
        />
      </motion.div>

      {/* Overseas Section */}
      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
        <Overseas/>
      </motion.div>

      {/* English Exam Guide */}
      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
        <EnglishExamGuide/>
      </motion.div>
    </div>
  )
}

export default Testprep;
